import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { dateFormat, getDateTime } from "../../../utils/date";
import { API_HOST } from "../../../Constants";
import { apiWrapper } from "../../../apis/CommonApi";
import * as fireonApi from '../../../apis/FireOnApi';
import PageHeader from "../../PageHeader";

export default function FireInspectionScheduleDetailComponent() {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { firefightingObject, scheduleId } = location.state;
  const [dataSource, setDataSource] = useState(null);

  console.log(firefightingObject, scheduleId)

  useEffect(() => {
    apiWrapper(async () => {
      const { status, data } = await fireonApi.getFireFightingInspectionScheduleDetail(scheduleId);
      if (status === true) {
        setDataSource(data);
      } else {
        alert(`${data}`)
      }
    });
  }, []);

  const handleDelete = () => {
    if (window.confirm("삭제하시겠습니까?")) {
      apiWrapper(async () => {
        const { status, data } = await fireonApi.bulkDeleteFireFightingInspectionSchedule(scheduleId);
        alert(`${data}`)

        //삭제 성공 시 뒤로가기
        if (status === true) {
          navigate(-1);
        }
      });
    }
  }

  return (
    <section class="mbSection reseonSection">
      <PageHeader isBlack={false} title="소방설비점검일정" isUseMenu={false} />
      {dataSource && (
        <div class="container">
          <div class="item-cont-wrap">
            <div class="item-detail-wrap">
              <div class="item-img-wrap">
                <img src={API_HOST + firefightingObject.buildingPhoto} alt="" />
              </div>
              <div class="item-info-wrap">
                <p class="info-title">{firefightingObject.buildingName}</p>
                <p class="info-adr">{`${firefightingObject.roadAddress} ${firefightingObject.roadAddressDetail}`}</p>
              </div>
            </div>
          </div>
          <div class="greyBox">
            <div class="grey-row">
              <p class="row-title">점검 시작</p>
              <p class="row-value">{getDateTime(new Date(dataSource.startDate))}</p>
            </div>
            <div class="grey-row">
              <p class="row-title">예상 점검 종료</p>
              <p class="row-value">{getDateTime(new Date(dataSource.endDate))}</p>
            </div>
            <div class="grey-row">
              <p class="row-title">점검자 정보</p>
              <div class="row-value-wrap">
                <p class="row-value">{dataSource.inspector}</p>
                <span class="divi"></span>
                <p class="row-value">{dataSource.contact}</p>
              </div>
            </div>
          </div>
          <div class="reason-item-wrap">
            <p class="wrap-title">점검 사유</p>
            <div class="reason-item">
              <p class="reason-title">{dataSource.reason}</p>
              <div class="item-date">
                <p class="item-title">등록일 :&nbsp;</p>
                <p class="reason-date">{dateFormat(new Date(dataSource.createdAt))}</p>
              </div>
            </div>
          </div>
          <div class="btn-wrap">
            <Link
              class="btn btn-line"
              to={`/fire-on/fire-inspection-schedule/${id}/add/`}
              state={{
                scheduleInfo: dataSource
              }}
            >
              수정
            </Link>
            <button class="btn btn-line" onClick={handleDelete}>삭제</button>
          </div>
        </div>
      )}
    </section>
  );
}
